module.exports = __webpack_public_path__ + "static/media/iconEdit2.28d2bb8a.svg";